import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classNames from 'classnames';

import { env } from 'settings/env';

import styles from './Sticker.module.scss';

export type Props<C extends ElementType = 'div'> = {
  as?: C;
  sticker: {
    label: string;
    image?: {
      src: string;
      alt?: string;
    };
    background?: string;
    color?: string;
  };
} & Omit<ComponentPropsWithoutRef<C>, 'children'>;

export default function Sticker<C extends ElementType = 'div'>({
  sticker: { label, image, background, color },
  as,
  className,
  style,
  ...props
}: Props<C>): JSX.Element {
  const As = as || 'div';

  return (
    <As
      className={classNames(styles.sticker, className)}
      style={{
        ...(background ? { background } : {}),
        ...(color ? { color } : {}),
        ...style,
      }}
      {...props}
    >
      {label}
      {image && (
        <img
          src={`${env.ENV_WYSIWYG_OCTIPAS_URL}/sticker/${image.src}_lp.png`}
          alt={image.alt}
          className={styles.image}
        />
      )}
    </As>
  );
}
